"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnsLogs = void 0;
require("../../../../core");
const components_1 = require("../../../../components");
const convertCellProps = (fieldProps, rowData) => ({
    cellData: rowData[fieldProps.field],
    rowData,
    rowIndex: 0,
    columnWidth: 1,
});
const getColumnsLogs = (t) => [
    {
        field: 'createTimeUtc',
        title: t('sessionsLogDialog|columns|log|createTimeUtc'),
        cellRenderer: (fieldProps, rowData) => components_1.datetimeCellRenderer()(convertCellProps(fieldProps, rowData)),
        widthColumn: '180px',
    },
    {
        field: 'status',
        title: t('sessionsLogDialog|columns|log|status'),
        cellRenderer: (fieldProps, rowData) => components_1.statusCellRenderer()(convertCellProps(fieldProps, rowData)),
        widthColumn: '120px',
    },
    {
        field: 'title',
        title: t('sessionsLogDialog|columns|log|description'),
        cellRenderer: components_1.textWithLinkTableCellRenderer({
            kb: t('sessionsLogDialog|link|KB'),
            userGuide: t('sessionsLogDialog|link|UserGuide'),
        }),
        widthColumn: '400px',
    },
    {
        field: 'duration',
        title: t('sessionsLogDialog|columns|log|duration'),
        cellRenderer: (fieldProps, rowData) => components_1.durationBetweenCellRenderer({
            startName: 'createTimeUtc',
            stopName: 'updateTimeUtc',
        })(convertCellProps(fieldProps, rowData)),
    },
];
exports.getColumnsLogs = getColumnsLogs;
//# sourceMappingURL=getColumnsLogs.js.map